export default __webpack_public_path__ + "static/media/manage-user.309d83d5.svg";